module.exports = __webpack_public_path__ + "static/media/4.221f26ae.png";